'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookContextPage = require('@narvar/nth-hook-context-page');
var nthHookGlobalSettings = require('@narvar/nth-hook-global-settings');
var nthHookLoma = require('@narvar/nth-hook-loma');
var graphql = require('../graphql.js');
var types = require('../types.js');

const useUnsubscribeNotificationPreferenceMutate = ({
  data: notificationPreferencesAndLevelData,
  options
}) => {
  const {
    state: pageContext
  } = nthHookContextPage.usePageContext();
  const {
    globalSettings: {
      hipaaCompliant
    }
  } = nthHookGlobalSettings.useGlobalSettingsX();
  const {
    experienceHost,
    embedReferrerUrl,
    requestUrl,
    trackingNumbers,
    orderNumbers
  } = pageContext;
  const referrerUrl = experienceHost === 'EMBED' && embedReferrerUrl ? embedReferrerUrl : requestUrl ?? window?.location.href;
  const trackingNumber = (trackingNumbers && trackingNumbers[0]) ?? '';
  // in the context of messaging API, orderNumber is called orderId
  const orderId = (orderNumbers && orderNumbers[0]) ?? '';
  const notificationPreferences = notificationPreferencesAndLevelData?.getNotificationPreferencesAndLevel ?? undefined;
  const {
    preferenceLevel,
    modifiedDatetime = '',
    isActive,
    isGuest
  } = notificationPreferences ?? {};
  const [mutate, {
    loading
  }] = nthHookLoma.useUnsubscribeNotificationPreferencesAllLevelsMutation({
    refetchQueries: [graphql.getNotificationPreferencesAndLevelQuery],
    awaitRefetchQueries: true,
    ...options
  });
  const onUnsubscribeMutate = currentChannel => {
    mutate({
      variables: {
        ...pageContext,
        preferenceLevel: preferenceLevel || types.PreferenceLevels.TRACKING,
        retailerMoniker: pageContext.retailerMoniker,
        trackingNumber,
        orderId,
        channel: currentChannel,
        modifiedDatetime,
        isActive,
        isGuest,
        referrerUrl,
        hipaaCompliant
      }
      // eslint-disable-next-line no-console
    }).catch(error => console.log(error));
  };
  return {
    onUnsubscribeMutate,
    loading
  };
};

exports.useUnsubscribeNotificationPreferenceMutate = useUnsubscribeNotificationPreferenceMutate;
